var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c(
            "div",
            { staticClass: "box" },
            [
              _c(
                "b-menu",
                [
                  _c(
                    "b-menu-list",
                    { attrs: { label: "Mis datos" } },
                    [
                      _c("b-menu-item", {
                        attrs: {
                          icon: "id-badge",
                          label: "Información",
                          tag: "router-link",
                          to: { name: "perfilInformacion" },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-menu-list",
                    { attrs: { label: "Mi cuenta" } },
                    [
                      _c("b-menu-item", {
                        attrs: {
                          icon: "key",
                          label: "Cambiar clave",
                          tag: "router-link",
                          to: { name: "perfilClave" },
                        },
                      }),
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          icon: "signature",
                          label: "Elegir firmador",
                          tag: "router-link",
                          to: { name: "perfilFirmador" },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-menu-list",
                    { attrs: { label: "Soporte" } },
                    [
                      _c("b-menu-item", {
                        attrs: {
                          icon: "external-link-alt",
                          label: "Centro de Ayuda Lyris IT",
                          tag: "a",
                          target: "_blank",
                          href: "https://soporte-lyris.atlassian.net/servicedesk/customer/portals",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          icon: "external-link-alt",
                          label: "Documentación Signar",
                          tag: "a",
                          target: "_blank",
                          href: "https://docs.signar.com.ar",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-menu-list",
                    { attrs: { label: "Acciones" } },
                    [
                      _c("b-menu-item", {
                        attrs: {
                          icon: "sign-out-alt",
                          label: "Cerrar sesión",
                          tag: "router-link",
                          to: { name: "logout" },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column is-9" },
          [_c("router-view", { on: { update: _vm.updateUser } })],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }